import { mediaQueriesMixin } from './mediaQueries';

export const heroBannerMixin = {
    props: {
        backgroundColor: {
            type: String,
            default: 'transparent',
        },
        paddingBottom: {
            type: String,
            default: '20px',
        },
        titleFontSize: {
            type: String,
            default: '20px',
        },
        hideSubtitleOnMobile: {
            type: Boolean,
            default: false,
        },
        hideSubtitleOnDesktop: {
            type: Boolean,
            default: false,
        },
        subTitleFontSize: {
            type: String,
            default: '16px',
        },
        titleAlign: {
            type: String,
            default: 'left',
        },
        bannerHeight: {
            type: String,
            default: '200px',
        },
        bannerMobileHeight: {
            type: String,
            default: '120px',
        },
        titleDesktopFontSize: {
            type: String,
            default: '28px',
        },
        titleMobileFontSize: {
            type: String,
            default: '16px',
        },
        subTitleDesktopFontSize: {
            type: String,
            default: '16px',
        },
        subTitleMobileFontSize: {
            type: String,
            default: '10px',
        },
    },
    mixins: [mediaQueriesMixin],
    computed: {
        hideSubTitle() {
            return (
                (this.isMobileDevice() && this.hideSubtitleOnMobile) ||
                (this.isDesktop() && this.hideSubtitleOnDesktop) ||
                this.titleBottomShadow
            );
        },
        getFixedHeight() {
            if (this.isMobile()) {
                return this.bannerMobileHeight;
            } else if (this.isTablet()) {
                return this.bannerMobileHeight;
            } else {
                return this.bannerHeight;
            }
        },
        getTitleFontSize() {
            if (this.isMobileDevice()) {
                return this.titleMobileFontSize;
            }
            return this.titleDesktopFontSize;
        },
        getSubTitleFontSize() {
            if (this.isMobileDevice()) {
                return this.subTitleMobileFontSize;
            }
            return this.subTitleDesktopFontSize;
        },
    },
};
